// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","year":"footer_year__7z68k"};